import {
  ApplicationConfig,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
} from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import {
  provideHttpClient,
  withInterceptors,
  HttpBackend,
  HttpClient,
} from "@angular/common/http";
import {
  authInterceptor,
  errorInterceptor,
  redirectDemoUserInterceptor,
} from "./auth/auth.interceptor";

import { firstValueFrom, timeout } from "rxjs";
import { Url } from "./services/api/Url";
import { configureWaterYearHold } from "./field-claim/map/util/utliWaterYear";

export const appConfig: ApplicationConfig = {
  providers: [
    // Load before components calculate slider limits or claiming date bounds.
    // Bypass auth/demo interceptors: this public configuration is shared by all roles.
    provideAppInitializer(() => {
      const http = new HttpClient(inject(HttpBackend));
      return firstValueFrom(
        http
          .get<{ rolloverHeld: boolean }>(Url + "/water-year-config")
          .pipe(timeout(15000)),
      ).then((config) => configureWaterYearHold(config.rolloverHeld));
    }),
    provideHttpClient(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        redirectDemoUserInterceptor,
        errorInterceptor,
      ]),
    ),
  ],
};
